import { Button, Card, Col, Divider, message, Row, Spin } from "antd"
import { backgroundStyle } from "./styles"
import useApiClient from "hooks/useApiClient"
import { useHistory } from "react-router-dom"
import { useCurrentUserQuery } from "@timenotes/shared/src/services/users-accounts/queries/use-current-user-query"
import useSearchParams from "hooks/use-search-params"
import { useEffect } from "react"

const AutoLoginPage = () => {
  const theme = 'light'
  const history = useHistory()


  const [searchParams] = useSearchParams<{
    clientType?: 'mobile' | 'extension'
    accessToken?: string
  }>()
  const clientType = searchParams.clientType

  // Set it as params mobile or extension as a default for any other value
  const paramsClientType = (clientType === 'mobile') ? 'mobile' : 'extension'

  const apiClient = useApiClient()

  // If mobile is present in params type it means it is a fresh flow for the mobile app
  // so it should avoid reusing already existing logged in flow to avoid re-login again
  if (paramsClientType != 'mobile') {
    apiClient.loadAccessCredentials()
  }

  //window.localStorage.setItem('autoLoginType', 'extension')

  // In order to ensure it is not only loaded to the local storage
  // but also the tokens are actually valid ones and works with the API 
  // NOT needed as we will validate access token and account id via request
  //const isAuthenticated = (apiClient.accessToken && apiClient.accountId) 
  const { currentUserQuery } = useCurrentUserQuery({
    onSuccess: () => {
      // message.success('Current user exists and access token is correct')

      // TODO: Mobile Deep LInk strategy
      //window.location.href = `exp://auth-callback?accessToken=${apiClient.accessToken}&accountId=${apiClient.accountId}`;
      //return

      const sessionAutoLoginType = window.localStorage.getItem('autoLoginType')

      if (sessionAutoLoginType == 'mobile') {
        // Handle mobile redirect
        window.location.href = `timenotes://auth?accessToken=${apiClient.accessToken}&accountId=${apiClient.accountId}`

      } else {
        // Handle extension and web flows


        // HANDLE EXTENSION
        window.postMessage({
          type: "AUTO_LOGIN",
          data: {
            accessToken: apiClient.accessToken,
            accountId: apiClient.accountId
          }
        }, "*");
      }

      // Clear auto login type if exists
      window.localStorage.removeItem('autoLoginType')
    },
    onError: () => {
      //message.error('Current user unable to fetch, access token is incorrect')

      // Mark the session storage so later when user logs in inside this browser session
      // he will be redirected to extension message instead of logging in in the web app
      window.localStorage.setItem('autoLoginType', paramsClientType)

      if (clientType == 'mobile') {
        if (searchParams.accessToken) {
          // Store given access token for mobile in order to allow partial login flow 
          // from select account case up-ward
          window.localStorage.setItem('accessToken', searchParams.accessToken)
          apiClient.accessToken = searchParams.accessToken

          history.push('/auth/select-account')
        } else {
          history.push('/auth/login')
        }
      } else {
        history.push('/auth/login')
      }
    }
  })

  const LoadingView = () => (
    <Spin size="large" />
  )

  const SuccessView = () => (<>
    <h1>
      You have successfully logged in!
    </h1>
    <p>
      You can close this window and get back to the application.
    </p>
    <Divider />
    <p>
      <Button
        type="primary"
        onClick={() => {
          history.push('/timer')
        }}
      >
        Continue in Timenotes
      </Button>
    </p>
  </>)

  return (
    <div className="h-100" style={backgroundStyle}>
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={24} sm={22} md={20} lg={13}>
            <Card>

              <div className="my-2">
                <div className="text-center">
                  <img className="img-fluid" src={`/img/${theme === 'light' ? 'logo.png' : 'logo-white.png'}`} alt="" />
                </div>
                <Row justify="center">
                  {currentUserQuery.isFetched ? <SuccessView /> : <LoadingView />}
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AutoLoginPage